import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { ClasseProfitComponent } from './classeProfit/classe-profit.component';
import { FNSimpleComponent } from './fNSimple/fN-simple.component';
import { Step2CommonComponent } from './steps/step2/step2common.component';
import { TypeAdresseFNSComponent } from './typeAdresseFNS/type-adresseFNS.component';
import { TypeAdresseTEMPOSTComponent } from './typeAdresseTEMPOST/type-adresseTEMPOST.component';
import { TypeOuiNonComponent } from './typeOuiNon/type-oui-non.component';
import { TypeOuiNonGrpAcheteurComponent } from './typeOuiNonGrpAcheteur/type-oui-non-grp-acheteur.component';
import { TypeNumIdentificationNationalComponent } from './typeNumIdentificationNational/type-num-identification-national.component';
import { OuiComponent } from './oui/oui.component';
import { TypeMotsClefComponent } from './typeMotsClef/type-mots-clef.component';


@NgModule({
  declarations: [
    
ClasseProfitComponent,
OuiComponent,
TypeOuiNonComponent,
FNSimpleComponent,
TypeAdresseFNSComponent,
TypeAdresseTEMPOSTComponent,
TypeOuiNonGrpAcheteurComponent,
TypeNumIdentificationNationalComponent,
TypeMotsClefComponent,
Step2CommonComponent ],
  exports: [
    Step2CommonComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule, SharedModule
  ]
})
export class FormfnsimpleCommonModule {
}

